import { useStaticQuery, graphql } from "gatsby";
import {
  mergePrismicPreview,
  resolveImage,
  resolveByPrefix,
  resolveExtraGroups,
  keysToCamel,
  resolveEmbeddedDocuments,
} from "@dataResolvers";

const query = graphql`
  query PortfolioPageQuery {
    prismicPortfolioPage {
      id
      data {
        hero {
          heading {
            raw
          }
        }
        testimonials {
          quote {
            html
          }
          person
          title
          photo {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
        overview_heading
        overview_intro {
          html
        }
        overview_description {
          html
        }
        featured_heading {
          raw
        }
        featured_subheading
        featured_items {
          company {
            document {
              ... on PrismicCompanies {
                id
                data {
                  name
                  tagline
                  description {
                    html
                  }
                  status
                  status_subtitle
                  exited
                  white_logo {
                    url
                    alt
                    dimensions {
                      width
                      height
                    }
                  }
                }
              }
            }
          }
          image {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
        companies_heading {
          raw
        }
        companies_subheading
        companies_items {
          company {
            document {
              ... on PrismicCompanies {
                id
                data {
                  company_url
                  name
                  tagline
                  status
                  status_subtitle
                  exited
                  short_description {
                    html
                  }
                  description {
                    html
                  }
                  color_logo {
                    url
                    alt
                    dimensions {
                      width
                      height
                    }
                  }
                }
              }
            }
          }
        }
        prefooter {
          heading {
            raw
          }
          subheading
          description {
            html
          }
          cta_text
          cta_link {
            url
            target
          }
          image {
            url
            alt
            dimensions {
              width
              height
            }
          }
        }
        meta_title
        meta_description
        meta_image {
          url
          dimensions {
            width
            height
          }
        }
      }
    }
  }
`;

const dataResolver = response => {
  const { prismicPortfolioPage } = response;
  const { prefixed, unPrefixed } = resolveByPrefix(prismicPortfolioPage.data, [
    "featured_",
    "overview_",
    "companies_",
    "meta_",
  ]);
  const { featured, overview, companies, meta } = prefixed;

  const unGrouped = resolveExtraGroups(unPrefixed);

  return keysToCamel({
    ...unGrouped,
    overview,
    featured: {
      ...featured,
      companies: featured.items.map(item => ({
        ...resolveEmbeddedDocuments(item.company),
        logo: resolveImage(resolveEmbeddedDocuments(item.company).white_logo),
        image: resolveImage(item.image),
      })),
    },
    companies: {
      ...companies,
      companies: companies.items
        .map(item => ({
          ...resolveEmbeddedDocuments(item.company),
          logo: resolveImage(resolveEmbeddedDocuments(item.company).color_logo),
        }))
        // sort alphabetically
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        }),
    },
    testimonials: unPrefixed.testimonials.map(item => ({
      ...item,
      photo: resolveImage(item.photo),
    })),
    meta: {
      ...meta,
      image: resolveImage(meta.image),
    },
  });
};

const useData = () => {
  const response = useStaticQuery(query);
  const data = mergePrismicPreview(response);
  return dataResolver(data);
};

export default useData;
